import { Box, Typography } from "@mui/material";
import React from "react";
import PhoneOutlinedIcon from "@mui/icons-material/PhoneOutlined";
import MailOutlineOutlinedIcon from "@mui/icons-material/MailOutlineOutlined";
import PinDropOutlinedIcon from "@mui/icons-material/PinDropOutlined";
import LinkedInIcon from "@mui/icons-material/LinkedIn";
import YouTubeIcon from "@mui/icons-material/YouTube";
import TelegramIcon from "@mui/icons-material/Telegram";
import InstagramIcon from "@mui/icons-material/Instagram";
import TwitterIcon from "@mui/icons-material/Twitter";

const ContactUs = () => {
  return (
    <Box sx={{ marginTop: "20px" }}>
      <Box sx={{ mb: "24px" }}>
        <Typography
          sx={{
            fontFamily: "Tahrir",
            fontWeight: 500,
            fontSize: "32px",
            mb: "8px",
          }}
        >
          Get in touch
        </Typography>
        <Box sx={{ display: "flex", flexDirection: "column" }}>
          <Box sx={{ display: "inline-flex", mb: "14px" }}>
            <PhoneOutlinedIcon sx={{ mr: "6px", color: "darkMute.main" }} />

            <a href='tel:+982165023189'>
              <Typography sx={{ color: "gray.main" }}>+982165023189</Typography>
            </a>
          </Box>

          <Box sx={{ display: "inline-flex", mb: "14px" }}>
            <MailOutlineOutlinedIcon
              sx={{ mr: "6px", color: "darkMute.main" }}
            />
            <a href='mailto:azadapplication@gmail.com'>
              <Typography sx={{ color: "gray.main" }}>
                Azadapplication@gmail.com
              </Typography>
            </a>
          </Box>

          <Box sx={{ display: "inline-flex" }}>
            <PinDropOutlinedIcon sx={{ mr: "6px", color: "darkMute.main" }} />
            <Typography sx={{ color: "gray.main" }}>
              No 504, Sharif Tech Tower, Salehi, Akbari, Azad St, Tehran, Iran,
              Postal Code: 1459993599
            </Typography>
          </Box>
        </Box>
      </Box>
      <Box sx={{ mb: "16px" }}>
        <Typography
          sx={{
            fontFamily: "Tahrir",
            fontWeight: 500,
            fontSize: "32px",
            mb: "8px",
          }}
        >
          Follow us on social media
        </Typography>
        <Box sx={{ display: "flex", flexDirection: "column" }}>
          <Box sx={{ display: "inline-flex", mb: "14px" }}>
            <TwitterIcon sx={{ mr: "6px", color: "darkMute.main" }} />
            <a href='https://t.me/azadsocial'>
              <Typography sx={{ color: "gray.main" }}>@azadsocial</Typography>
            </a>
          </Box>
          <Box sx={{ display: "inline-flex", mb: "14px" }}>
            <InstagramIcon sx={{ mr: "6px", color: "darkMute.main" }} />
            <a href='https://www.instagram.com/azadsocial/'>
              <Typography sx={{ color: "gray.main" }}>@azadsocial</Typography>
            </a>
          </Box>
          <Box sx={{ display: "inline-flex", mb: "14px" }}>
            <YouTubeIcon sx={{ mr: "6px", color: "darkMute.main" }} />
            <a href='https://www.youtube.com/@azadsocial'>
              <Typography sx={{ color: "gray.main" }}>@azadsocial </Typography>
            </a>
          </Box>

          <Box sx={{ display: "inline-flex", mb: "14px" }}>
            <TelegramIcon sx={{ mr: "6px", color: "darkMute.main" }} />
            <a href='https://t.me/azadsocial'>
              <Typography sx={{ color: "gray.main" }}>@azadsocial</Typography>
            </a>
          </Box>
          <Box sx={{ display: "inline-flex" }}>
            <LinkedInIcon sx={{ mr: "6px", color: "darkMute.main" }} />
            <a href='https://linkedin.com/company/azadsocial'>
              <Typography sx={{ color: "gray.main" }}>@azadsocial</Typography>
            </a>
          </Box>
        </Box>
      </Box>
    </Box>
  );
};

export default ContactUs;
